export function randomSeed() {
    return Math.floor(Math.random() * 4294967296);
}
